// ============================================================================
// ClientCalendarSync — the client portal's "Add my training to my calendar"
// section, wiring the client ICS-subscription hooks to the shared
// CalendarSubscribeCard. The feed covers ONLY this client's own training,
// read-only + auto-updating; edits still happen in ViccoFitness.
//
// Strings come from the `clientPortal` namespace under the `calendarSync.*`
// subtree — the same key shape the trainer realm uses in `common`, so the one
// shared card renders identical, namespace-translated copy in both realms.
// ============================================================================
import { useTranslation } from "react-i18next";
import { CalendarSubscribeCard } from "../../components";
import {
  useClientCalendarSubscription,
  useRotateClientCalendarSubscription,
} from "../hooks";

export function ClientCalendarSync({ className }: { className?: string }) {
  const { t } = useTranslation("clientPortal", { keyPrefix: "calendarSync" });
  const sub = useClientCalendarSubscription();
  const rotate = useRotateClientCalendarSubscription();

  return (
    <CalendarSubscribeCard
      t={t}
      url={sub.data?.ics_url ?? null}
      isLoading={sub.isLoading}
      isError={sub.isError}
      onRetry={() => void sub.refetch()}
      onRotate={() => rotate.mutate()}
      isRotating={rotate.isPending}
      rotateFailed={rotate.isError}
      className={className}
    />
  );
}
